import React from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={`/${largeImage}`} title={title} target="_blank" rel="noopener noreferrer">
          {title && (
            <div className="hover-text">
              <h4>{title}</h4>
            </div>
          )}
          <img src={`/${smallImage}`} className="img-responsive" alt={title || "ESSI project photo"} loading="lazy" />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
